import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { CwpModule } from '@ddt-web/cwp';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { ExploreCardModule, HomePageLeftNavModule, PortfolioSelectionCardsModule } from '@ddt-web/models-browsing';

import { MiniCompareBarModule } from '../mini-compare-bar';
import { ModelsHomeComponent } from './models-home.component';

@NgModule({
	declarations: [ModelsHomeComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		DataServiceModule,
		DisclosureModule,
		HomePageLeftNavModule,
		ExploreCardModule,
		PortfolioSelectionCardsModule,
		MiniCompareBarModule,
		CwpModule,
		RouterModule.forChild([{ path: '', component: ModelsHomeComponent }])
	]
})
export class ModelsHomeModule { }
